import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useAlert } from "react-alert";

export default function AboutUsContainer() {
    let alert = useAlert();
    const [value, setValue] = useState('.');

    React.useEffect(() => {
        getAboutUs()
    }, [])

    const getAboutUs = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getAboutUs`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setValue(data[0].content);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener las noticias", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    var modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean'], [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }]
        ],
    }

    var formats = [
        'header', 'align',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]

    const saveAboutUs = () => {
        fetch(`${process.env.REACT_APP_URL_API}/data/saveAboutUs`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({ value }),
        }).then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0) {
                    alert.show("Datos Guardados", {
                        timeout: 2000,
                        type: "success",
                        onClose: () => {
                            window.location.reload();
                        },
                    });
                }
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al guardar los datos, por favor intenta de nuevo " +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    return <>
        <div className="row">
            <p className='text-center'>Agrega o modifica el apartado de quiénes somos</p>
        </div>
        <button className="btn btn-success mb-2" onClick={() => {
            saveAboutUs()
        }}>Guardar</button>
        {value && <ReactQuill theme="snow" value={value} modules={modules}
            formats={formats} onChange={setValue} />}
    </>
}